import {ShapeCommand} from '../../commands.template';

export class FlowlineAddInteractionCommand extends ShapeCommand {
  services: any;

  constructor(data) {
    super(data);
  }

  public prepareData() {
    return this;
  }

  public execute() {
    super.execute();
    const graph = this.services.editorRegistrySvc.getGraph();
    const edge = graph.model.getCell(this.object.flowlineMxKey);
    const lineJson = edge.getJson();
    const value = (this.services.jsonHandlerSvc.get().interactions || []).length + 1;

    const interactionCell = this.services.shapeSpawnerSvc.createInteractionCell(
      this.object,
      value,
      lineJson
    );

    graph.addCell(interactionCell, edge);

    const action = {
      createInteraction: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        offset: this.object.offset,
        description: this.object.description
      }
    };

    this.services.diagramUpdateSvc.update(action);
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();
    const interactionCell = graph.model.getCell(`${this.object.flowlineMxKey}-ian`);

    graph.removeCells([interactionCell], false);

    const action = {
      deleteInteraction: {
        flowlineMxKey: Number(this.object.flowlineMxKey)
      }
    };

    this.services.diagramUpdateSvc.update(action);
  }
}
